import TranslatedComponent from './TranslatedComponent';
export default TranslatedComponent;
